import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";
import { Eyebrow, Reveal, stagger, fadeUp } from "./motion";
import { PROBLEM } from "../config/content";

export default function Problem() {
  return (
    <section id="why-us" className="py-16 md:py-24 bg-[#0B110D]" data-testid="problem-section">
      <div className="max-w-[1180px] mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>{PROBLEM.eyebrow}</Eyebrow>
          <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl leading-none tracking-wide" data-testid="problem-heading">
            THIS PAGE IS FOR <span className="text-[#22C55E]">YOU</span> IF...
          </h2>
        </Reveal>
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-4"
          data-testid="problem-grid"
        >
          {PROBLEM.items.map((item, i) => (
            <motion.div
              key={i}
              variants={fadeUp}
              className="card-hover flex items-start gap-3 rounded-xl bg-[#120B0B] border border-[#EF4444]/25 p-5"
              data-testid={`problem-card-${i}`}
            >
              <AlertTriangle className="w-5 h-5 text-[#EF4444] shrink-0 mt-0.5" />
              <p className="text-sm sm:text-base text-[#A7B3AA] leading-relaxed">{item}</p>
            </motion.div>
          ))}
          <motion.div
            variants={fadeUp}
            className="card-hover sm:col-span-2 lg:col-span-1 rounded-xl bg-[#0F1712] border border-[#22C55E]/40 p-6 shadow-[0_0_50px_-12px_rgba(34,197,94,0.35)]"
            data-testid="problem-closing-card"
          >
            <p className="font-heading uppercase text-xl sm:text-2xl text-white leading-tight">
              If you said <span className="text-[#FACC15]">"yes"</span> to even one, the problem is <span className="text-[#22C55E]">not you</span>.
            </p>
            <p className="mt-3 text-sm sm:text-base text-[#A7B3AA] leading-relaxed">
              You just never had a system, a mentor, or a room full of serious traders.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
